import { useSelector, useDispatch } from 'react-redux'
import { setTrainingChartSelectedWeekOfTheYearKey } from 'redux/slices/trainingChart'
import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'

import ContentFrame from 'components/Frame/ContentFrame'
import TrainingChartSettings from 'components/TrainingChart/TrainingChartSettings'
import KinesisProgramWeeks from 'components/Athlete/v2/KinesisProgramWeeks/KinesisProgramWeeks'
import TrainingChartWorkoutColumn from 'components/TrainingChart/TrainingChartWorkoutColumn'

export default function TrainingChart({ kinesisEvents = [] }) {

    const dispatch = useDispatch()

    const workoutTemplateKeys = ['strength-session-a', 'strength-session-b', 'mobility-a', 'mobility-b']

    const trainingChartWorkoutTemplateFilter = useSelector(state => state.trainingChart.filters.workoutTemplateFilter)
    const trainingChartPresentWeekOfTheYearKey = useSelector(state => state.trainingChart.trainingChartPresentWeekOfTheYearKey)
    const trainingChartSegmentDomain = useSelector(state => state.trainingChart.trainingChartSegmentDomain)
    const trainingChartSegment = useSelector(state => state.trainingChart.trainingChartSegment)
    const trainingChartSelectedWeekOfTheYearKey = useSelector(state => state.trainingChart.trainingChartSelectedWeekOfTheYearKey)

    const OnPreviousWeekButton = () => {
        const newWeekOfTheYearKey = new WeekOfTheYearKey(trainingChartSelectedWeekOfTheYearKey).add(-1)
        dispatch(setTrainingChartSelectedWeekOfTheYearKey(newWeekOfTheYearKey.toString()))
    }

    const OnSetWeekButton = (newWeekOfTheYearKey) => {
        dispatch(setTrainingChartSelectedWeekOfTheYearKey(newWeekOfTheYearKey.toString()))
    }

    const OnNextWeekButton = () => {
        const newWeekOfTheYearKey = new WeekOfTheYearKey(trainingChartSelectedWeekOfTheYearKey).add(1)
        dispatch(setTrainingChartSelectedWeekOfTheYearKey(newWeekOfTheYearKey.toString()))
    }

    return (
        <ContentFrame className='relative'>
            <TrainingChartSettings />

            <KinesisProgramWeeks
                displaySize='large'
                presentWeekAlignment='left'
                disableNaivationWhenModalIsOpen={false}
                trainingChartPresentWeekOfTheYearKey={trainingChartPresentWeekOfTheYearKey}
                trainingChartSelectedWeekOfTheYearKey={trainingChartSelectedWeekOfTheYearKey}
                trainingChartSegmentDomain={trainingChartSegmentDomain}
                trainingChartSegment={trainingChartSegment}
                kinesisEvents={kinesisEvents}
                NavigateCalendarToPreviousWeek={OnPreviousWeekButton}
                NavigateCalendarToSpecificWeek={OnSetWeekButton}
                NavigateCalendarToNextWeek={OnNextWeekButton}
            />

            <div
                className="w-full px-16 grid"
                style={{ gridTemplateColumns: `repeat(${trainingChartSegmentDomain}, minmax(0, 1fr))` }}
            >
                {trainingChartSegment.map((trainingChartDataColumn, index) => (
                    <div 
                        key={index}
                        className="col-span-1 px-[4px]"
                    >
                        {workoutTemplateKeys.map((workoutTemplateKey) => (
                            <div key={workoutTemplateKey}>
                                <TrainingChartWorkoutColumn
                                    showWorkoutTemplate={trainingChartWorkoutTemplateFilter.includes(workoutTemplateKey)}
                                    trainingChartDataColumn={trainingChartDataColumn}
                                    workoutTemplateKey={workoutTemplateKey}
                                    isPresent={new WeekOfTheYearKey(trainingChartDataColumn.weekOfTheYearKey).equals(new WeekOfTheYearKey(trainingChartPresentWeekOfTheYearKey))}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </ContentFrame>
    )
}